export default __webpack_public_path__ + "static/uiux3-13ea4a4a7a9727bb0d1148fc58715083.jpg";